module.exports = __webpack_public_path__ + "assets/fonts/Gotham-Ultra.1321eca6.otf";